import Sales from './sales';

export default Sales;